
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 47.4 131.2"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{staticClass:"st0",attrs:{"cx":"23.2","cy":"27.1","r":"10"}}),_c('path',{staticClass:"st0",attrs:{"d":"M44.9 3C44.5 1.5 43.2.5 41.7.5c-.4 0-.9.1-1.3.3-1.5.6-2.3 2.4-1.9 4 1.1 4.1 1.7 8.3 1.8 12.5.1 2.3.1 4-.3 7.3-.3 2.4-.8 5.5-1.8 9.1-1 3.6-4.3 6-8 6H17.7c-4.1 0-7.6-2.8-8.7-6.7-.8-3.3-1.3-6.2-1.5-8.5-.4-3.3-.4-4.9-.3-7.3.1-4.2.7-8.4 1.8-12.5.4-1.6-.4-3.4-1.9-4C6.6.6 6.2.5 5.7.5 4.3.5 2.9 1.5 2.5 3 .6 10.3.1 17.8.8 25.2c.6 5.8 1.8 12 5.1 16.9 0 0 0 .1.1.1 3.4 4.9 5.3 10.7 5.3 16.7v12.8h24.8V59c0-6 1.9-11.8 5.3-16.7 0 0 0-.1.1-.1 3.3-4.9 4.4-11.1 5.1-16.9.8-7.5.2-15-1.7-22.3zM11.3 73.8l-.7 51c0 3.3 2.7 6 6 6s6-2.7 6-6V83.9h2.3v40.8c0 3.3 2.7 6 6 6s6-2.7 6-6l-.7-51H11.3z"}})])
          )
        }
      }
    